import React from "react";

interface TabItem {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  component: React.ComponentType;
}

interface TrashTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TrashTabs: React.FC<TrashTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="trash-tabs">
      <div className="trash-tabs__list">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              className={`trash-tabs__item ${isActive ? "trash-tabs__item--active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              <Icon size={18} className="trash-tabs__item-icon" />
              <span className="trash-tabs__item-text">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TrashTabs;
